import { TicketStatus } from "../../services/LiveQueueService";
export const TicketStatusFilter = [
  { value: TicketStatus.NEW, label: "New" },
  { value: TicketStatus.ARRIVED, label: "Arrived" },
  { value: TicketStatus.CHECKED_IN, label: "Checked In" },
  { value: TicketStatus.NO_SHOW, label: "No Show" },
  { value: TicketStatus.IN_PROGRESS, label: "In Progress" },
  { value: TicketStatus.AWAITING_INFO, label: "Awaiting Info" },
  { value: TicketStatus.HOLD, label: "Hold" },
  { value: TicketStatus.CANCELLED, label: "Cancelled" },
  { value: TicketStatus.COMPLETED, label: "Completed" },
  { value: TicketStatus.ARCHIVED, label: "Archived" },
  { value: TicketStatus.RESERVED, label: "Reserved" },
];
